import React, { useState, useEffect } from 'react';
import SalesDetailPage from './SalesDetailPage';
import { SETTLEMENTS_COLUMNS, SORT_TYPES, getDefaultVisibleColumns, getDefaultHiddenColumns } from '../constants/settlementsColumnsConfig';
import { currencyFormatter, compactCurrency } from '../utils/reportingUtils';
import { buildSettlementsFilterGroups } from '../constants/settlementsFiltersConfig';

const axios = require('axios').default;

export const SETTLEMENTS_CONFIG = {
  pageTitle: 'Settlements',
  pageSubtitle: 'Settlement tracking across your venues.',
  sidebarKey: 'finances_settlements',
  defaultPreset: 'year_to_date',
  dateModeOptions: [
    { key: 'event_date', label: 'Event Date' },
  ],

  columns: SETTLEMENTS_COLUMNS,
  sortTypes: SORT_TYPES,
  getDefaultVisibleColumns,
  getDefaultHiddenColumns,
  localStorageKey: (teamId) => `reportingFinancesSettlementColumns_${teamId}`,
  firstColumnId: 'event_name',
  defaultSortRules: [{ field: 'event_date', direction: 'desc' }],

  kpiFromDetailResponse: false,
  salesDataKey: null,
  venueSeriesKey: null,
  exportBasePath: (teamId) => `/teams/${teamId}/reporting/finances/settlements/export`,
  detailEndpoint: (teamId) => `/teams/${teamId}/reporting/finances/settlements/data.json`,
  detailResponseKey: 'rows',
  detailErrorMessage: 'Failed to load settlements data.',
  detailTableTitle: 'Settlements',
  emptyMessage: 'No settlements found.',
  searchPlaceholder: 'Search settlements...',
  paginationLabel: 'settlements',
  itemLabel: (count) => `settlement${count !== 1 ? 's' : ''}`,

  buildKpiCards: () => [],
  kpiGridColumns: 0,

  chartColor: '#1565c0',
  salesCardIsCurrency: true,
  salesCardTitle: 'Settlements',
  buildMetricValue: () => '',
  buildMetricLabel: () => '',
  overTimeKey: null,
  countLabel: 'settlements',

  topCharts: [],

  groupByOptions: [],
  groupByDefault: null,

  renderCellValue: (col, row, { formatEventDate, formatEventDateTime, currencyFormatter: cf, team }) => {
    switch (col.id) {
      case 'event_date': return <span className="text-nowrap">{row.event_date ? formatEventDate(row.event_date) : '\u2014'}</span>;
      case 'event_name':
        if (!row.event_name) return '\u2014';
        if (team && team.id && row.event_id) {
          return <a href={`/teams/${team.id}/confirms/${row.event_id}`}>{row.event_name}</a>;
        }
        return row.event_name;
      case 'artist_name': return row.artist_name || '\u2014';
      case 'venue_name': return row.venue_name || '\u2014';
      case 'payment_status':
        return row.payment_status === 'Paid'
          ? <span className="badge" style={{ background: 'var(--sl-bg-success-primary, #ecfdf3)', color: 'var(--sl-text-success, #027a48)', fontSize: 12 }}>Paid</span>
          : <span className="badge" style={{ background: 'var(--sl-bg-error-primary, #fef3f2)', color: 'var(--sl-text-error, #b42318)', fontSize: 12 }}>Unpaid</span>;
      case 'settlement_paid_at': return <span className="text-nowrap">{row.settlement_paid_at ? formatEventDateTime(row.settlement_paid_at) : '\u2014'}</span>;
      case 'payment_method': return row.payment_method || '\u2014';
      case 'notes': return row.notes || '\u2014';
      case 'total_due': return cf.format(row.total_due || 0);
      default: return '\u2014';
    }
  },

  filterTitle: 'Filter Settlements',
  filterSubtitle: 'Apply filters to narrow settlement data.',
};

const buildDetailApiFilters = (activeFilters) => {
  const params = {};
  if (activeFilters.venue_name && activeFilters.venue_name.length > 0) {
    params.venue_name = activeFilters.venue_name;
  }
  if (activeFilters.event_name && activeFilters.event_name.length > 0) {
    params.event_name = activeFilters.event_name;
  }
  if (activeFilters.payment_status && activeFilters.payment_status.length > 0) {
    params.payment_status = activeFilters.payment_status;
  }
  if (activeFilters.payment_method && activeFilters.payment_method.length > 0) {
    params.payment_method = activeFilters.payment_method;
  }
  return params;
};

function ReportingFinancesSettlementsPage({ team, csrfToken, ...props }) {
  const [filterOptions, setFilterOptions] = useState({});

  useEffect(() => {
    if (!team || !team.id) return;
    if (csrfToken) axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.get(`/teams/${team.id}/reporting/finances/settlements/filter_options.json`)
      .then((res) => setFilterOptions(res.data || {}))
      .catch(() => {});
  }, [team && team.id, csrfToken]);

  const configWithFilters = {
    ...SETTLEMENTS_CONFIG,
    buildFilterGroups: () => buildSettlementsFilterGroups(filterOptions),
    urlFilterIds: ['payment_status'],
    buildDetailApiFilters,
  };
  return <SalesDetailPage {...props} team={team} csrfToken={csrfToken} config={configWithFilters} />;
}

export default ReportingFinancesSettlementsPage;
